import React from 'react';
import { Spin } from 'antd';
import cn from 'classnames';
import styles from './StepContainer.module.scss';

const StepContainer = ({ className, children }) => {
  return <div className={cn(styles.root, className)}>{children}</div>;
};

StepContainer.BoundingWrap = ({ className, children, grow = false }) => {
  return (
    <div
      className={cn(styles.boundingWrap, className, { [styles.grow]: grow })}
    >
      {children}
    </div>
  );
};

StepContainer.Row = ({ className, children }) => {
  return <div className={cn(styles.row, className)}>{children}</div>;
};

StepContainer.Title = ({ className, children }) => {
  return <h2 className={cn(styles.title, className)}>{children}</h2>;
};

StepContainer.Footer = ({ className, extra, children }) => {
  return (
    <div className={cn(styles.footer, className)}>
      {extra}
      <div className={styles.footerRow}>{children}</div>
    </div>
  );
};

StepContainer.Spin = ({ className, ...props }) => (
  <Spin
    {...props}
    className={cn(styles.spin, className)}
  />
);

export default StepContainer;
